// src/utils/skill.js

// Add skill points and dispatch update event
export const addSkillPoints = (points) => {
  const current = parseInt(localStorage.getItem("skillPoints") || "0");
  const updated = current + points;
  localStorage.setItem("skillPoints", updated.toString());

  // Notify listeners (e.g., SkillMeter, ChapterMap)
  const event = new Event("skillPointsUpdated");
  window.dispatchEvent(event);
};

// Get current skill points
export const getCurrentSkillPoints = () => {
  return parseInt(localStorage.getItem("skillPoints") || "0", 10);
};
